import React from 'react';
import { useAuth } from '../context/AuthContext';
import { ShieldX } from 'lucide-react';
import { Button } from "@/components/ui/button";

const BanScreen = () => {
  const { user, isBanned, logout } = useAuth();

  if (!isBanned) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black flex items-center justify-center p-6" data-testid="ban-screen">
      <div className="max-w-lg w-full text-center space-y-6">
        <div className="mx-auto w-20 h-20 rounded-full bg-red-600/20 border-2 border-red-600/40 flex items-center justify-center">
          <ShieldX className="h-10 w-10 text-red-500" />
        </div>
        <h1 className="text-3xl font-black text-red-500">Hozzáférés megtagadva</h1>
        <p className="text-gray-400 text-lg">A fiókod bannolva lett a Gonzalez Road Services weboldalról.</p>
        {user?.ban_reason && (
          <div className="bg-red-900/20 border border-red-500/30 rounded-xl p-4" data-testid="ban-reason">
            <p className="text-xs text-red-400/70 uppercase tracking-wider mb-1">Indok</p>
            <p className="text-white font-semibold">{user.ban_reason}</p>
          </div>
        )}
        <p className="text-sm text-gray-600">Ha úgy gondolod, hogy tévedés történt, vedd fel a kapcsolatot egy adminisztrátorral a Discord szerveren.</p>
        <Button onClick={logout} variant="outline" className="border-red-500/30 text-red-400 hover:bg-red-500/10" data-testid="ban-logout-btn">
          Kijelentkezés
        </Button>
      </div>
    </div>
  );
};

export default BanScreen;
